module.exports = __webpack_public_path__ + "assets/e1b5534ca203692e794e46c6bfe8fa84.mp3";